import { Point, Rectangle, Rectangles } from '@mos/client/shared/utils'
import { Particle } from './particle'

export function getRandomPointInRectangle(rectangle: Rectangle): Point {
	return {
		x: rectangle.x + Math.random() * rectangle.width,
		y: rectangle.y + Math.random() * rectangle.height,
	}
}

export function getRandomPointInParticleArea(particleArea: Rectangles): Point {
	const areas = Array.isArray(particleArea) ? particleArea : [particleArea]
	if (!areas.length) throw new Error('No particle area provided')
	return getRandomPointInRectangle(areas[Math.floor(Math.random() * areas.length)])
}

export function isInParticuleArea(x: number, y: number, particleArea: Rectangles): boolean {
	const contains = (rec: Rectangle, x: number, y: number): boolean => {
		return x >= rec.x && x <= rec.x + rec.width && y >= rec.y && y <= rec.y + rec.height
	}
	return Array.isArray(particleArea)
		? particleArea.some((area) => contains(area, x, y))
		: contains(particleArea, x, y)
}

export function getCenterOffRectangle(rectangle: Rectangle): Point {
	return {
		x: rectangle.x + rectangle.width / 2,
		y: rectangle.y + rectangle.height / 2,
	}
}

export function averageCenterOfRectangles(rectangles: Rectangle[]): Point {
	const centers = rectangles.map(getCenterOffRectangle)
	const x = centers.reduce((sum, center) => sum + center.x, 0) / centers.length
	const y = centers.reduce((sum, center) => sum + center.y, 0) / centers.length
	return { x, y }
}

export function getCenterOfParticleArea(particleArea: Rectangles): Point {
	return Array.isArray(particleArea) ? averageCenterOfRectangles(particleArea) : getCenterOffRectangle(particleArea)
}

/**
 * Should return a normalized direction vector from the center of the particle area to the particle (1, 0) means the particle is on the right of the center of the particle area
 */
export function getParticleDirectionFromCenter(particle: Particle): Point {
	const center = getCenterOfParticleArea({ x: 0, y: 0, ...particle.displayArea })
	const direction = {
		x: particle.x - center.x,
		y: particle.y - center.y,
	}

	const length = Math.abs(direction.x) + Math.abs(direction.y)

	return {
		x: direction.x / length,
		y: direction.y / length,
	}
}
